// extracted by mini-css-extract-plugin
module.exports = {"code":"D_cG"};